import { render, staticRenderFns } from "./ibanEditor.vue?vue&type=template&id=a960fc9c"
import script from "./ibanEditor.vue?vue&type=script&lang=js"
export * from "./ibanEditor.vue?vue&type=script&lang=js"
import style0 from "./ibanEditor.vue?vue&type=style&index=0&id=a960fc9c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports